export { default } from './Dialog';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Dialog/index.js
// module id = 232
// module chunks = 2